export const SORT_UNDEFINED = 'last';
export const EARNINGS_INSIGHTS_COLUMN_ID = 'earning_insights';
